<template>
  <div
    v-if="message"
    class="flex select-none rounded-lg px-2 text-xs"
    :class="theme === 'light' && !special ? 'text-rose-6' : 'text-rose'">
    {{ message }}
  </div>
  <div
    v-else
    class="h-4" />
</template>

<script setup lang="ts">
import type { EffectiveTheme } from '@/helpers/settings';

defineProps<{
  message?: string;
  special?: boolean;
  theme?: EffectiveTheme;
}>();
</script>
